import React, { useMemo, type ReactNode } from 'react';
import WorkspaceContext from './context';
import { useDefaultWorkspace } from '../../hooks/useDefaultWorkspace';

import WorkspaceEmptyModal from '../../views/base/WorkspaceEmptyModal';
interface WorkspaceContextProviderProps {
  children: ReactNode;
}

const WorkspaceContextProvider = ({ children }: WorkspaceContextProviderProps) => {
  const workspace = useDefaultWorkspace();

  const value = useMemo(() => ({
    workspace,
  }), [workspace]);

  return (
    <WorkspaceContext.Provider value={value}>
      {children}

      <WorkspaceEmptyModal />
    </WorkspaceContext.Provider>
  );
};
export default WorkspaceContextProvider;
